/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-27 17:53:06
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-22 00:12:21
 * @FilePath: /goldenSalesMobile/src/api/order.js
 * @Description: 订单相关api
 */
import { requestOfPut, requestOfGet, requestOfPost } from "../utils/http";
const baseUrl = "wechath5/zh-cn/v1/coupon";

// 获取消费者的优惠券
export function getUserCouponList(param) {
  return requestOfGet(baseUrl, param);
}
export function getMyTicketList(param) {
  return requestOfGet(baseUrl + "/groupticket", param);
}
export function getMyTicketCount(param) {
  return requestOfGet(baseUrl + "/avaliblecount", param);
}
export function transferMyTicket(param) {
  return requestOfPost(baseUrl + "/transfer", param);
}
export function receiveCoupon(param) {
  return requestOfPost(baseUrl + "/transfer/receive", param);
}
export function getReceiveCouponInfo(param) {
  return requestOfGet(baseUrl + "/transfer/" + param.id, param);
}
export function getPayCouponList(param) {
  return requestOfGet(baseUrl + "/order/" + param.orderId, param);
}
